// Country list (Arabic labels + ISO-3166 alpha-2 codes) for the business
// signup form. The value stored is the Arabic name so the admin email/SMS is
// human-readable. `code` is used to match the IP-detected country.
const COUNTRIES = [
  { code: 'PS', ar: 'فلسطين' },
  { code: 'IL', ar: 'إسرائيل' },
  { code: 'JO', ar: 'الأردن' },
  { code: 'SA', ar: 'السعودية' },
  { code: 'AE', ar: 'الإمارات' },
  { code: 'QA', ar: 'قطر' },
  { code: 'KW', ar: 'الكويت' },
  { code: 'BH', ar: 'البحرين' },
  { code: 'OM', ar: 'عُمان' },
  { code: 'EG', ar: 'مصر' },
  { code: 'LB', ar: 'لبنان' },
  { code: 'SY', ar: 'سوريا' },
  { code: 'IQ', ar: 'العراق' },
  { code: 'YE', ar: 'اليمن' },
  { code: 'LY', ar: 'ليبيا' },
  { code: 'TN', ar: 'تونس' },
  { code: 'DZ', ar: 'الجزائر' },
  { code: 'MA', ar: 'المغرب' },
  { code: 'SD', ar: 'السودان' },
  { code: 'MR', ar: 'موريتانيا' },
  { code: 'SO', ar: 'الصومال' },
  { code: 'DJ', ar: 'جيبوتي' },
  { code: 'KM', ar: 'جزر القمر' },
  { code: 'TR', ar: 'تركيا' },
  { code: 'US', ar: 'الولايات المتحدة' },
  { code: 'GB', ar: 'المملكة المتحدة' },
  { code: 'CA', ar: 'كندا' },
  { code: 'FR', ar: 'فرنسا' },
  { code: 'DE', ar: 'ألمانيا' },
  { code: 'ES', ar: 'إسبانيا' },
  { code: 'IT', ar: 'إيطاليا' },
  { code: 'NL', ar: 'هولندا' },
  { code: 'SE', ar: 'السويد' },
  { code: 'AU', ar: 'أستراليا' },
  { code: 'IN', ar: 'الهند' },
  { code: 'PK', ar: 'باكستان' },
  { code: 'ID', ar: 'إندونيسيا' },
  { code: 'MY', ar: 'ماليزيا' },
];

export function findCountryByCode(code) {
  if (!code) return null;
  const upper = String(code).toUpperCase();
  return COUNTRIES.find((c) => c.code === upper) || null;
}

export default COUNTRIES;
